if (!customElements.get('sticky-atc')) {
  class StickyAtc extends HTMLElement {
    constructor() {
      super();

      this.titleWrapper = this.querySelector('[data-title]');
      this.productSection = document.querySelector('[data-product-wrapper]');
      this.productSectionAtc = this.productSection.querySelector('[data-product-atc]');
      this.variantsSelectWrapper = this.productSection.querySelector('[data-variant-selection]');
      this.variatsSelect = this.variantsSelectWrapper.querySelector('[name="id"][data-variants');
    }

    connectedCallback() {
      if (!this.productSectionAtc) return;

      this.createObserver();

      this.variantsSelectWrapper.addEventListener('change', this.onVariantChange.bind(this));
    }
    
    createObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.classList.toggle('is-visible', !entry.isIntersecting);
          document.body.classList.toggle('sticky-atc-visible', !entry.isIntersecting);
        });
      });

      const resizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          document.documentElement.style.setProperty('--sticky-atc-height', `${entry.target.offsetHeight}px`);
        });
      });
  
      observer.observe(this.productSectionAtc);
      resizeObserver.observe(this);
    }

    onVariantChange() {
      const selectedOption = this.variatsSelect.selectedOptions[0];

      this.titleWrapper.textContent = selectedOption.textContent;
    }
  }

  customElements.define('sticky-atc', StickyAtc);
}